<template>
    <b-container fluid="xl" class="pl-3 pr-3 pl-lg-5 pr-lg-5 pl-xl-0 pr-xl-0" v-if="course">
        <b-row class="mt-3 mb-4">
            <b-col class="title" cols="12">
                О программе
            </b-col>
        </b-row>
        <b-row>
            <b-col class="d-block d-lg-none text-center mb-5">
                <img :src="course.image_description.path" v-if="course.image_description" class="image_description">
            </b-col>
        </b-row>
        <b-row align-v="top">
            <b-col cols="12" lg="6" xl="8">
                <b-row v-if="course.description">
                    <b-col class="content" cols="12" xl="6" v-html="description[0]">
                    </b-col>
                    <b-col class="content" cols="12" xl="6" v-html="description[1]">
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" lg="6" xl="4" class="d-none d-lg-block text-right">
                <img :src="course.image_description.path" v-if="course.image_description" class="image_description">
            </b-col>
        </b-row>
        <b-row style="margin-left: -48px" align-v="end">
            <b-col cols="6" md="3" lg="2" class="mb-4 mb-md-0">
                <div class="number">{{course.age_in}} - {{course.age_out}}</div>
                <div class="number_text">Возраст детей</div>
            </b-col>
            <b-col cols="6" md="3" lg="2" class="mb-4 mb-md-0">
                <div class="number">{{course.hours}}</div>
                <div class="number_text">Продолжительность программы {{course.hours}} {{getNoun(course.hours, 'час',
                    'часа', 'часов')}}
                </div>
            </b-col>
            <b-col cols="6" md="3" lg="2">
                <div class="number">{{course.hours_per_week/hours_per_lesson}}</div>
                <div class="number_text">Занятия проходят {{course.hours_per_week/hours_per_lesson}} {{getNoun(course.hours_per_week/hours_per_lesson,
                    'раз', 'раза', 'раз')}} в неделю
                </div>
            </b-col>
            <b-col class="mt-4" cols="6" md="3" lg="2" v-for="(format, i) in course.course_format" :key="'format'+i">
                <div v-if="format">
                    <div class="number_format">{{format}}</div>
                    <div class="number_text">Форма<br/>обучения</div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "Description",
        computed: {
            course: function () {
                return this.$store.getters.currentCourse;
            },
            description: function () {
                return this.course.description.split("<hr>");
            },
            hours_per_lesson: function () {
                return (this.course.hours_per_lesson)?this.course.hours_per_lesson:2
            }
        },
        methods: {
            getNoun: function (number, one, two, five) {
                let n = Math.abs(number);
                n %= 100;
                if (n >= 5 && n <= 20) {
                    return five;
                }
                n %= 10;
                if (n === 1) {
                    return one;
                }
                if (n >= 2 && n <= 4) {
                    return two;
                }
                return five;
            }
        }
    }
</script>

<style scoped>
    .title {
        font-family: SF BOLD, sans-serif;
        font-style: normal;
        font-size: 32px;
        line-height: 42px;
        color: #9D9E9E;
    }

    .content {
        padding-right: 32px;
        font-family: SF, sans-serif;
        font-style: normal;
        font-size: 16px;
        line-height: 24px;
        color: var(--text-secondary-color);
    }

    .number {
        font-family: SF SEMIBOLD, sans-serif;
        font-style: normal;
        text-align: center;
        font-size: 42px;
        line-height: 42px;
        color: #FECC00;
        padding-bottom: 8px;

    }

    .number_text {
        padding: 0px 24px;
        font-family: SF MEDIUM, sans-serif;
        text-align: center;
        font-style: normal;
        font-size: 12px;
        line-height: 14px;
        color: var(--text-secondary-color);
    }

    .number_format {
        font-family: SF SEMIBOLD, sans-serif;
        font-style: normal;
        text-align: center;
        font-size: 32px;
        line-height: 32px;
        color: #FECC00;
        padding-bottom: 8px;
        text-transform: uppercase;
    }


    .image_description {
        width: 100%;
        max-width: 460px;
    }

    @media all and (max-width: 800px) {
        .number, .number_format {
            font-size: 30px;
        }
    }
</style>